export const appRoutes = {
  admin: {
    tasks: {
      list: '/admin/tasks',
    },
    employees: {
      list: '/admin/employees',
      new: '/admin/employees/new',
      edit: '/admin/employees/:id',
    },
    travelers: {
      list: '/admin/travelers',
      new: '/admin/travelers/new',
      edit: '/admin/travelers/:id',
      view: '/admin/travelers/:id/view',
    },
    travelerManagers: {
      new: '/admin/traveler-managers/new',
      edit: '/admin/traveler-managers/:id',
    },
    enquiries: {
      list: '/admin/enquiries',
      edit: '/admin/enquiries/:id',
    },
    orders: {
      overview: '/admin/overview',
    },
    quotes: {
      list: '/admin/quotes',
      edit: '/admin/quotes/:id',
    },
    airports: {
      list: '/admin/airports',
    },
    airlines: {
      list: '/admin/airlines',
    },
    suppliers: {
      list: '/admin/suppliers',
      new: '/admin/suppliers/new',
      edit: '/admin/suppliers/:id',
    },
    accommodations: {
      list: '/admin/accommodations',
      new: '/admin/accommodations/new',
      edit: '/admin/accommodations/:id',
    },
    bookings: {
      list: '/admin/bookings',
      view: '/admin/bookings/:id',
    },
    companiesV2: {
      list: '/admin/companies-v2',
      new: '/admin/companies-v2/new',
      edit: '/admin/companies-v2/:id',
      view: '/admin/companies-v2/:id/view',
      primaryContactEdit: '/admin/companies-v2/:id?activeTab=2',
    },
    carHireSuppliers: {
      list: '/admin/car-hire-suppliers',
    },
    transferVendors: {
      list: '/admin/transfer-vendors',
    },
    railSuppliers: {
      list: '/admin/rail-suppliers',
    },
    cruiseLines: {
      list: '/admin/cruise-lines',
    },
    carTypes: {
      list: '/admin/car-types',
    },
  },
  auth: {},
};
